"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_security(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "4c9f12ed-2746-4414-a2ee-8b5664af27b8",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "armed-state"), /*#__PURE__*/React.createElement("g", {
    id: "9f08e636-e91d-4c57-a6bf-817edb87cfa8",
    "data-name": "c29d6958-9153-4755-9357-3a503e2d1e09"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f915913c-1ae5-4bd8-af0c-0be4fefd76c3",
    "data-name": "06a5ea59-4373-419c-b5a9-1302b1498da3"
  }, /*#__PURE__*/React.createElement("line", {
    id: "d2661afd-c0e4-4db3-802c-27c50556112e",
    "data-name": "453b792d-2c21-4d64-82e3-ec828741851d",
    x1: 96,
    y1: 100,
    x2: 96,
    y2: 148,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "03d73869-a3c8-4cd5-8b93-e961fcd03e4b",
    "data-name": "948daef7-463a-457e-895b-15d58357490f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 76,
    width: 120,
    height: 96,
    rx: 12,
    ry: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68,76V48A28,28,0,0,1,96,20h0a28,28,0,0,1,28,28V76",
    transform: "translate(0)",
    strokeLinejoin: "round"
  })));
}

var _default = ic_security;
exports.default = _default;